import { DataType } from 'ka-table/enums';
import { TableColumn } from '../../components/table/table';
import { StatusControl } from '../../components/buttons/status';
import { useApiType } from '../../helper/apiHook';

export const columns = (actions: any): TableColumn[] => {
    const appId = sessionStorage.getItem('appId')

    return [
        {
            key: 'id',
            title: 'id',
            dataType: DataType.Number,
            visible: false,
        },
        /* {
            key: 'account',
            title: 'Account Code',
            dataType: DataType.String,
            callBack: (row) => { },
        }, */
        {
            key: 'accountName',
            title: 'Account Name',
            dataType: DataType.String,
        },
        {
            key: 'balance',
            title: 'Balance',
            dataType: DataType.String,
            callBack: (row) => { },
        },
        {
            key: 'accountCreditUser',
            title: 'Credit Amount',
            dataType: DataType.Number,
            style: { textAlign: 'center', },
            valueConvert: (row: any) => { return row != null ? Number(row).toFixed(2) : '0.00'; },
        },
        {
            key: 'accountDebitUser',
            title: 'Debit Amount',
            dataType: DataType.Number,
            style: { textAlign: 'center', },
            valueConvert: (row: any) => { return row != null ? Number(row).toFixed(2) : '0.00'; },
        },
        {
            key: 'accountBalance',
            title: appId + " Balance",
            dataType: DataType.Number,
            style: { textAlign: 'center', },
            valueConvert: (row: any) => { return row != null ? Number(row).toFixed(2) : '0.00'; },
        },
        {
            key: 'accountCreditApi',
            title: appId + " Credit Amount",
            dataType: DataType.Number,
            style: { textAlign: 'center', },
            valueConvert: (row: any) => { return row != null ? Number(row).toFixed(2) : '0.00'; },
        },
        {
            key: 'accountDebitApi',
            title: appId + " Debit Amount",
            dataType: DataType.Number,
            style: { textAlign: 'center', },
            valueConvert: (row: any) => { return row != null ? Number(row).toFixed(2) : '0.00'; },
        },
        {
            key: 'accountDebitUserDiff',
            title: 'Difference Amount',
            dataType: DataType.Number,
            style: { textAlign: 'center', },
            valueConvert: (row: any) => { return row != null ? Number(row).toFixed(2) : '0.00'; },
        },
    ];
};
